import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextTheme from "components/General/Text/TextTheme"
import Button from "@material-ui/core/Button";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton"
import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import DefaultGroupPic from "site_media/images/groups_default.png";
import "containers/ProjectCommon.css";
import * as CONSTANT from "constants/text";
import { withStyles } from '@material-ui/core/styles';
import MuiCardMedia from '@material-ui/core/CardMedia';

const RoundedCardImage = withStyles((theme) => ({
    img: {
      clipPath: "circle(50px)",
    },
}))(MuiCardMedia);


class ImgMediaCard extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        inviteTitle: CONSTANT.INVITE,
        viewTitle: CONSTANT.BUTTON_VIEW,
        buttonClassName: "background_dark_orange",
        buttonDisabled: false
    }
    // function binding
    this.searchResultViewClick = this.searchResultViewClick.bind(this);
  }

  searchResultImageClick(value) {
    this.props.searchResultImageClick([
      this.props.imageSrc,
      this.props.imageId,
      this.props.imageName,
      this.props.imageFullName
    ]);
    this.setState((prevState) => ({
        inviteTitle: CONSTANT.SELECTED,
        buttonClassName: "background_med_grey",
        buttonDisabled: true
    }));
  }

  searchResultViewClick(value) {
    this.props.searchResultInviteClick([
      this.props.imageName,
       this.props.type,
        this.props.groupName,
         this.props.groupID
        ]);
  }

  removeInviteClick(value) {
    this.props.removeInviteClick(this.props.imageId);
  }

 /*Used on the project invite search to route to the friend's profile page*/
 onProfileClick(){
    if (this.props.type !== CONSTANT.FRIENDS && this.props.type !== CONSTANT.RECOMMENDATIONS && this.props.type !== CONSTANT.GROUPS){
        window.open(`/profile/${CONSTANT.FRIEND}/${this.props.imageName}/`);
    }
 }

  render() {
    return (
      <Card
        className ={this.props.type === CONSTANT.RECOMMENDATIONS? "friends_search_card_border1" : "friends_search_card_border2"}
        style = {{borderRadius: "6px"}}
        onClick={this.props.type === CONSTANT.RECOMMENDATIONS? this.searchResultViewClick: null}
      >
        <div style={{ paddingTop: "20px" }}>
          <RoundedCardImage
            className="friends_search_card"
            style={{
                objectFit: "contain",
                objectPosition: "center",
                cursor: this.props.type !== CONSTANT.FRIENDS 
                        && this.props.type !== CONSTANT.RECOMMENDATIONS 
                        && this.props.type !== CONSTANT.GROUPS? "pointer" : "auto"
            }}
            component="img"
            /*Depending on where the search originated from, show a different default pic.*/
            image={this.props.imageSrc ?
                    this.props.imageSrc : this.props.type === CONSTANT.GROUPS? DefaultGroupPic :UploadPhoto}
            alt="Impact Project"
            onClick={this.onProfileClick.bind(this)}
          />

          <CardContent className="friends_search_card_text" style = {{paddingTop:"6px"}}>
            {this.props.type !== CONSTANT.GROUPS?this.props.imageFullName:this.props.imageName}
          </CardContent>
        </div>

        {this.props.removeInviteClick ? (
          <CardActions>
            <div
              style={{ width: "100%", textAlign: "center" }}
            >
              <Button
                size="small"
                color="primary"
                onClick={this.removeInviteClick.bind(this)}
              >
                Remove Invite
              </Button>
            </div>
          </CardActions>
        ) : (

          <div style={{ width: "100%", textAlign: "center"}} >
                {this.props.type === CONSTANT.FRIENDS
                 || this.props.type === CONSTANT.NEW_MEMBERS
                 || this.props.type === CONSTANT.GROUPS?
                    (
                        <RoundedButton
                            buttonClassName = {this.state.buttonClassName}
                            title = {this.state.viewTitle}
                            textThemeClassName = "text_white text_small text_bold"
                            float= "none"
                            margin = "0px 10px 20px 10px"
                            width = "79%"
                            handleOnClick={this.searchResultViewClick.bind(this)}
                            borderRadius="6px"
                        />
                    ): this.props.type === CONSTANT.RECOMMENDATIONS ?(
                        <TextTheme message={this.props.location} className={"text_small text_med_grey"}/>
                    ):(
                        <RoundedButton
                            buttonClassName = {this.state.buttonClassName}
                            title = {this.state.inviteTitle}
                            textThemeClassName = "text_white text_small text_bold"
                            float= "none"
                            margin = "0px 10px 20px 10px"
                            width = "79%"
                            disabled = {this.state.buttonDisabled}
                            handleOnClick={this.searchResultImageClick.bind(this)}
                            borderRadius="6px"
                        />
                    )
                }
            </div>

        )}
      </Card>
    );
  }
}

export default ImgMediaCard;
